<template>
  <div class="app-content-wrapper">
    <div class="actions" v-permission="'checkout:brand:add'">
      <el-button type="primary" size="small" @click="add"> +{{ $t('message.checkout.addBrand') }} </el-button>
    </div>
    <div v-if="!brandList || brandList.length === 0" class="empty-wrapper">
      <img class="empty-img" src="../../../assets/images/brand-empty.png" />
      <div class="empty-text">{{ $t('message.checkout.noBrandTip') }}</div>
      <el-button type="primary" size="small" @click="add" v-permission="'checkout:brand:add'"> +{{ $t('message.checkout.addBrand') }} </el-button>
    </div>
    <template v-else>
      <div class="brand-list">
        <el-row :gutter="30">
          <el-col :span="8" v-for="(item, index) in brandList" :key="index">
            <div class="brand-item">
              <div class="main-color" :style="{'background-color': item.color ? item.color : '#00A2DD'}">
                <div class="dropdown-button">
                  <el-dropdown trigger="click">
                    <span class="el-dropdown-link">
                      <span class="i-dropdown-text"><i class="el-icon-more el-icon--right"></i></span>
                    </span>
                    <template slot="dropdown">
                      <el-dropdown-menu>
                        <div>
                          <div class="dropdown-popover-name">{{ $t('message.tableCommon.operation') }}</div>
                          <div @click="editItem(item)" v-permission="'checkout:brand:edit'">
                            <el-dropdown-item>
                              <div>{{ $t('message.tableCommon.edit') }}</div>
                            </el-dropdown-item>
                          </div>
                          <div @click="detailsItem(item)" v-permission="'checkout:brand:view'">
                            <el-dropdown-item>
                              <div>{{ $t('message.tableCommon.details') }}</div>
                            </el-dropdown-item>
                          </div>
                          <div @click="deleteItem(item)" v-permission="'checkout:brand:delete'">
                            <el-dropdown-item>
                              <div>{{ $t('message.tableCommon.delete') }}</div>
                            </el-dropdown-item>
                          </div>
                        </div>
                      </el-dropdown-menu>
                    </template>
                  </el-dropdown>
                </div>
              </div>
              <div class="content">
                <div class="logo">
                  <img class="logo-img" :src="item.logoImage" />
                </div>
                <div class="right">
                  <div class="name">{{ item.brand }}</div>
                  <div class="update-time">{{ item.updateTime }}</div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </template>
    <custom-message ref="customMessage" custom-class="brand-delete-confirm"></custom-message>
  </div>
</template>
<script>
import { Loading } from 'element-ui';

import CustomMessage from '@/components/modal/message-box/custom-message.vue';

import { queryBrandList, deleteBrand } from '../api/brand';

export default {
  components: { CustomMessage },
  data() {
    return {
      brandList: [],
    };
  },
  created() {
    this.refreshList();
  },
  methods: {
    refreshList() {
      const loading = Loading.service();
      queryBrandList().then((res) => {
        this.brandList = res;
        loading.close();
      }).catch(() => {
        loading.close();
      });
    },
    add() {
      this.$router.push({
        path: '/checkout/brand/add',
      });
    },
    editItem(item) {
      this.$router.push({
        path: '/checkout/brand/edit',
        query: { id: item.id },
      });
    },
    detailsItem(item) {
      this.$router.push({
        path: '/checkout/brand/view',
        query: { id: item.id },
      });
    },
    deleteItem(item) {
      this.$refs.customMessage.openHttpModal({
        titleHtml: this.$t('message.common.prompt'),
        contentHtml: `${this.$t('message.checkout.deleteBrandConfirm')}`,
        httpFunction: deleteBrand,
        params: { id: item.id },
        successFunction: this.refreshList,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import '~@/styles/variables.scss';
.actions {
  text-align: right;
  margin-bottom: 20px;
}
.empty-wrapper {
  text-align: center;
  padding-top: 200px;
  .empty-img {
    width: 150px;
    height: auto;
  }
  .empty-text {
    font-weight: 500;
    font-size: 14px;
    color: #3D3D3D;
    line-height: 28px;
    margin-bottom: 20px;
    margin-bottom: 10px;
  }
}
.brand-list {
  max-width: 960px;
}
.brand-item {
  height: 200px;
  background: #F1F5F7;
  border-radius: 10px 10px 10px 10px;
  overflow: hidden;
  margin-bottom: 30px;
  width: 100%;
  .main-color {
    height: 80px;
    position: relative;
    .dropdown-button {
      position: absolute;
      right: 20px;
      top: 20px;
    }
    .i-dropdown-text {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 20px;
      height: 30px;
      background: rgba(255,255,255,0.8);
      border-radius: 2px 2px 2px 2px;
      .el-icon-more {
        margin: 0;
        transform: rotate(90deg);
        font-size: 20px;
        color: $color-text-primary;
      }
    }
  }
  .content {
    display: flex;
    padding: 15px;
    height: 120px;
    width: 100%;
    box-sizing: border-box;
    align-items: flex-end;
    justify-content: flex-start;
    .logo {
      width: 50px;
      height: 50px;
      margin-right: 10px;
      overflow: hidden;
      flex-shrink: 0;
      .logo-img {
        height: 100%;
      }
    }
    .right {
      font-size: 14px;
      width: calc(100% - 60px);
      .name {
        font-weight: 500;
        color: $color-text-primary;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
      .update-time {
        font-weight: 400;
        color: rgba(38,67,115,0.6);
      }
    }
  }
}
.dropdown-popover-name {
  font-size: 14px;
  font-weight: 400;
  color: rgba(0,32,63,0.6);
  padding-left: 13px;
  width: 250px;
  line-height: 30px;
}
</style>
<style lang="scss">
.el-message-box__wrapper .el-message-box.brand-delete-confirm {
  width: 470px;
}
</style>
